import Vue from 'vue'
import Router from 'vue-router'
import DashboardRoute from './dashboard'
import WebManage from './webManage'
import ArticleManage from './articleManage'
import ServiceManage from './serviceManage'
import AdvertManage from './advertManage'
import SystemManage from './systemManage'

const _import = require('./_import_' + process.env.NODE_ENV)
Vue.use(Router)

export const constantRouterMap = [
  { path: '/login', name: 'login', component: _import('login/index'), hidden: true },
  DashboardRoute,
  WebManage,
  ArticleManage,
  ServiceManage,
  AdvertManage,
  SystemManage,
  { path: '*', redirect: '/home', hidden: true }
]

export default new Router({
  base: '/backstage',
  mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})

export const asyncRouterMap = []



// WEBPACK FOOTER //
// ./src/router/index.js